import "./Footer.css";

import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaPhone,
  FaYoutube
} from 'react-icons/fa';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-about">
          <img
            src="logo.png"
            alt="Logo da Banda Brasil Papaya"
            className="footer-logo"
          />
          <p className="footer-description">
            Nasceu com a missão de derrubar o estigma de que música instrumental é elitista e inacessível.
          </p>
        </div>

        <div className="footer-nav">
          <h3>MENU</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#banda">Sobre a Banda</a></li>
            <li><a href="#discografia">Discografia</a></li>
            <li>
              <a
                href="https://www.flickr.com/photos/201717672@N02/albums/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Galeria
              </a>
            </li>
            <li><a href="#agenda">Agenda</a></li>
            <li><a href="#app">Aplicativo</a></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h3>ATENDIMENTO</h3>
          <ul>
            <li>
              <a href="tel:+5548991441074">
                <FaPhone className="social-icon" />
                (48) 99144-1074
              </a>
            </li>
            <li>
              <a href="mailto:brasilpapaya@hotmail.com">
                <FaEnvelope className="social-icon" />
                brasilpapaya@hotmail.com
              </a>
            </li>
            <li>
              <a href="mailto:entretenimento.g3@gmail.com">
                <FaEnvelope className="social-icon" />
                entretenimento.g3@gmail.com
              </a>
            </li>
            <li>
              <a href="mailto:themagicplace@hotmail.com">
                <FaEnvelope className="social-icon" />
                themagicplace@hotmail.com
              </a>
            </li>
          </ul>

          <h3>REDES SOCIAIS</h3>
          <div className="footer-socials">
            <a
              href="https://www.instagram.com/brasilpapaya/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="social-icon" />
            </a>
            <a
              href="https://www.facebook.com/brasilpapaya.instrumental"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF className="social-icon" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCL8cveR8EAVP7PgZovvD5UQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube className="social-icon" />
            </a>
          </div>
        </div>
      </div>

      <div>
        <div className="footer-sponsors">
          <div>
            <h3>REALIZAÇÃO</h3>
            <div className="footer-sponsor-logos">
              <a
                href="https://www.themagicplace.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="magic-place.png"
                  alt="The Magic Place"
                  className="sponsor-logo"
                />
              </a>
            </div>
          </div>

          <div>
            <h3>INCENTIVADORES</h3>
            <div className="footer-sponsor-logos">
              <a
                href="https://www.fortatacadista.com.br/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="fort.png"
                  alt="Fort Atacadista"
                  className="sponsor-logo"
                />
              </a>
              <a
                href="https://www.tirol.com.br/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="tirol.png"
                  alt="Tirol"
                  className="sponsor-logo"
                />
              </a>
            </div>
          </div>

          <div>
            <h3>INCENTIVO ESTADUAL</h3>
            <div className="footer-sponsor-logos">
              <a
                href="https://www.cultura.sc.gov.br/editais-e-acoes/programa-de-incentivo-a-cultura/o-que-e-o-pic"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="pic.png"
                  alt="PIC"
                  className="sponsor-logo"
                />
              </a>
              <a
                href="https://cultura.sc.gov.br/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="sc.png"
                  alt="Fundação Catarinense"
                  className="sponsor-logo"
                />
              </a>
              <a
                href="https://cultura.sc.gov.br/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="fcc.png"
                  alt="Fundação Catarinense"
                  className="sponsor-logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {year} <strong>Cold Code LTDA</strong> · Todos os direitos reservados
        </p>
      </div>
    </footer>
  );
};

export default Footer;
